import type { User } from '@gcv/shared';

export const getAssigneeName = (
  bankGroups: { id: string; name: string }[],
  users?: Partial<User>[],
  groupIds?: string[],
  groups?: { id: string; name: string }[]
): string => {
  if (users && users.length) {
    return `${users[0].firstName} ${users[0].lastName}`;
  }

  if (groupIds && groupIds.length) {
    if (groupIds.length > 1) {
      return 'Multiple';
    }

    const bankGroup = bankGroups.find((g) => g.id === groupIds[0])?.name;
    if (!bankGroup && groups) {
      return groups[0]?.name || '--';
    }

    return bankGroup ?? '--';
  }

  return '--';
};
